module.exports = __webpack_public_path__ + "static/media/Investor-BRENNA PREISSER_1646328360712.9fac8d2c.vtt";